module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/contents/noimage_s500x500-ff7be1788a0ccc44e27028072f2f23de.png";